import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../app/axios";

// Thunk to fetch success progress data
export const fetchSuccessProgress = createAsyncThunk(
  "successProgress/fetchSuccessProgress",
  async (studentId) => {
    const response = await axios.get(
      `/successprogress/${studentId}`,
    );
    return response.data;
  },
);

const successProgressSlice = createSlice({
  name: "successProgress",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSuccessProgress.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSuccessProgress.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchSuccessProgress.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default successProgressSlice.reducer;
